/**
 * Improve INP by preloading JavaScript for the app modal on logged-out web.
 */
export const PRELOAD_LOGGED_OUT_APP_MODAL_110824 = 'PRELOAD_LOGGED_OUT_APP_MODAL_110824';
